import * as React from "react";
import { useNavigate } from "react-router-dom";
import "react-image-crop/dist/ReactCrop.css";
import CancelButton from "./cancel-button";
import { SkinData, CollectionDataCache } from "@/types";
import { backend } from "@/services/backend";
import CollectionSkinCard from "./collection-skin-card";
import LoadMoreButton from "./load-more-button";
import { ConfirmModal } from "./confirm-modal";
import MotionModal from "./motion-modal";
import { useWallet } from "@/context/WalletContext";
import { fetchData, ItemFileData } from "@/types/collection";
import CropImageModal from "./cropImage";
import { useSnackbar } from "notistack";
import ColectionSelectSkinList from "./skin-list";
import { normalizeImage } from "@/utils/format";
interface UploadAvatarProps {
  title: string;
  onAvatarChange: (
    file: File | string,
    nftNumber: string | null,
    index?: number
  ) => void;
  onClose?: () => void;
}

export default function UploadAvatar({
  title,
  onAvatarChange,
  onClose,
}: UploadAvatarProps) {
  const navigate = useNavigate();
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [selectedImage, setSelectedImage] = React.useState<string | null>(null);
  const [selectedSkin, setSelectedSkin] = React.useState<ItemFileData>();
  const [selectedSkinNftAddress, setSelectedSkinNftAddress] =
    React.useState<string>();
  const [selectedSkinIndex, setSelectedSkinIndex] = React.useState<number>();
  const [showCropModal, setShowCropModal] = React.useState(false);
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [displayCount, setDisplayCount] = React.useState(6);
  const [allSkins, setAllSkins] = React.useState<SkinData[]>([]);
  const [mySkins, setMySkins] = React.useState<SkinData[]>([]);
  const { walletAddress } = useWallet();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [imageDimensions, setImageDimensions] = React.useState<{
    width: number;
    height: number;
  } | null>(null);

  console.log("Avatar upload");

  /* 
    1 = background
    2 = avatar
  */

  React.useEffect(() => {
    backend.getTrackingCollcetions({}).then(allSkins => {
      // console.log(allSkins, "allSkins");
      // console.log("Title bg:", title)
      if (title === "BACKGROUND") {
        allSkins = allSkins.filter(skin => skin.category_id === 1);
      } else {
        allSkins = allSkins.filter(skin => skin.category_id === 2);
      }
      setAllSkins(allSkins);
    });
    if (walletAddress) {
      backend
        .getAvailableTrackingCollcetions(walletAddress)
        .then(availableSkins => {
          console.log(availableSkins, "availableSkins");
          if (title === "BACKGROUND") {
            availableSkins = availableSkins.filter(
              skin => skin.category_id === 1
            );
          } else {
            availableSkins = availableSkins.filter(
              skin => skin.category_id === 2
            );
          }
          setMySkins(availableSkins);
        });
    }
  }, []);

  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/heic",
    "image/heif",
  ];

  console.log(mySkins, "mySkins");
  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!allowedTypes.includes(file.type)) {
      enqueueSnackbar("Please upload JPG, PNG or iPhone photos (HEIC)", {
        SnackbarProps: {
          onClick: () => closeSnackbar(),
        },
        variant: "error",
      });
      e.target.value = "";
      return;
    }

    try {
      // 🔹 Format filter (HEIC → JPEG, other → JPEG through canvas)
      const normalizedFile = await normalizeImage(file);

      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        const objectUrl = reader.result as string;

        img.onload = () => {
          // Save size
          setImageDimensions({ width: img.width, height: img.height });
          // Save url
          setSelectedImage(objectUrl);
          setShowCropModal(true);
        };

        img.src = objectUrl;
      };

      reader.readAsDataURL(normalizedFile);
    } catch (err) {
      console.error("Image normalization failed", err);
      enqueueSnackbar("Failed to process image", { variant: "error" });
      e.target.value = "";
    }
  };

  const handleApplyConfirm = async () => {
    console.log(selectedSkinIndex, "selectedSkinIndex");
    setShowConfirmModal(false);
    const dataUrl = selectedSkin?.image;
    console.log("Image data url:", dataUrl);
    if (dataUrl) {
      try {
        // const data = await fetchData(dataUrl);
        onAvatarChange(dataUrl, selectedSkinNftAddress!, selectedSkinIndex);
      } catch (error) {
        console.error("Error loading skin image:", error);
      }
    }
  };

  const handleCropComplete = (croppedFile: File) => {
    onAvatarChange(croppedFile, null, undefined);
    setShowCropModal(false);
    setSelectedImage(null);
  };

  const handleLoadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (displayCount >= allSkins.length) {
        setDisplayCount(4);
      } else {
        setDisplayCount(prev => Math.min(prev + 4, allSkins.length));
      }
      setIsLoading(false);
    }, 300);
  };

  const onSkinSelectHandler = (
    itemData: ItemFileData,
    nftAddress: string,
    index?: number
  ) => {
    setSelectedSkin(itemData);
    setSelectedSkinNftAddress(nftAddress);
    setSelectedSkinIndex(index);
    setShowConfirmModal(true);
  };

  return (
    <div className="flex flex-col w-full items-center text-[28px] text-white">
      <div className="fixed top-0 left-0 right-0 z-30 flex justify-between items-center px-[20px] py-[10px] pointer-events-none bg-[#0099FE] max-w-[430px] mx-auto">
        <span>{`EDIT ${title}`}</span>
        <CancelButton onClick={onClose} />
      </div>
      <div
        className={`relative pt-[73px] pb-[30px] w-full ${
          showCropModal || showConfirmModal ? "hidden pointer-events-none" : ""
        }`}
      >
        <div className="flex flex-col w-full items-center px-[54px]">
          <div
            className="flex flex-col w-full text-center items-center justify-center relative cursor-pointer"
            onClick={() => {
              fileInputRef.current?.click();
            }}
          >
            <span className="py-4">UPLOAD PICTURE</span>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/jpeg,image/jpg"
              className="hidden"
              onChange={handleFileSelect}
            />
            <div
              className={`w-full relative ${
                title === "BACKGROUND" ? "aspect-[430/180]" : "aspect-square"
              }`}
            >
              <img
                src={
                  title === "BACKGROUND"
                    ? "/assets/upload_bg_picture.svg"
                    : "/assets/upload_picture.svg"
                }
                alt="upload-picture"
                className="w-full h-full object-contain"
              />
              <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] justify-center items-center">
                <div className="w-[46px] h-[41px] mx-auto">
                  <img src="/assets/upload-icon.svg" alt="Upload Icon" />
                </div>
                <div className="flex flex-col items-center text-[13px] font-spline-sans-mono pt-[5px]">
                  <span className="line-height-1">2000x2000</span>
                  <span className="line-height-1">&lt;5MB</span>
                </div>
              </div>
            </div>
          </div>

          {mySkins.length > 0 && title === "AVATAR" && (
            <div className="flex flex-col items-center justify-center">
              <span className="py-4">MY SKINS</span>
              <div className="grid gap-4 w-full grid-cols-2">
                {mySkins.map((item, index) => {
                  return (
                    <ColectionSelectSkinList
                      title={title}
                      key={index}
                      data={item}
                      onItemClick={onSkinSelectHandler}
                    />
                  );
                })}
              </div>
            </div>
          )}

          {mySkins.length > 0 && title === "BACKGROUND" && (
            <div className="flex flex-col items-center justify-center">
              <span className="py-4">MY SKINS</span>
              <div className="grid gap-4 w-full grid-cols-1">
                {mySkins.map((item, index) => {
                  return (
                    <ColectionSelectSkinList
                      title={title}
                      key={index}
                      data={item}
                      onItemClick={onSkinSelectHandler}
                    />
                  );
                })}
              </div>
            </div>
          )}

          <div className="flex flex-col items-center justify-center">
            <span className="py-4">ALL SKINS</span>
            <div
              className={`grid gap-4 w-full grid-cols-${
                title === "AVATAR" ? "2" : "1"
              }`}
            >
              {allSkins.slice(0, displayCount).map((item, index) => (
                <ColectionSelectSkinList
                  key={index}
                  data={item}
                  onItemClick={() => navigate(`/collection/${item.address}`)}
                  title={title}
                />
              ))}
            </div>
          </div>

          {allSkins.length > 6 && (
            <LoadMoreButton
              isLoading={isLoading}
              hasMore={displayCount < allSkins.length}
              onLoadMore={handleLoadMore}
            />
          )}
        </div>
      </div>

      <MotionModal isOpen={showCropModal}>
        <CropImageModal
          title={title}
          image={selectedImage || ""}
          imageDimensions={imageDimensions || { width: 0, height: 0 }}
          onClose={() => setShowCropModal(false)}
          onApply={handleCropComplete}
        />
      </MotionModal>

      <MotionModal isOpen={showConfirmModal} className="">
        <ConfirmModal
          onClose={() => setShowConfirmModal(false)}
          onApply={() => handleApplyConfirm()}
          item={selectedSkin!}
          title={title}
        />
      </MotionModal>
    </div>
  );
}
